import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CommonFAQ from "components/commonFAQ/CommonFAQ";
import { getFaq } from "redux/actions/UserFAQ";

function CustomerHelpFAQ() {
  const searchParams = new URLSearchParams(window.location.search);
  const page = searchParams.get("page");
  const type = searchParams.get("type");
  const parentId = searchParams.get("parentId");
  const isMobile = searchParams.get("isMobile") === "true";

  const paymentData = useSelector((state) => state.userFaq?.userFaq?.data);
  const dispatch = useDispatch();
  const filterData = {
    id: parentId,
    role: type,
  };

  useEffect(() => {
    dispatch(getFaq(filterData));
  }, []);

  let defaultHeading = "";
  const heading = page && type && parentId ? page : defaultHeading;

  return (
    <div>
      {heading ? (
        <CommonFAQ heading={heading} faq={paymentData} isMobile={isMobile} />
      ) : (
        <CommonFAQ />
      )}
    </div>
  );
}

export default CustomerHelpFAQ;
